import { CloseCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { WL_CONFIG } from 'constants';
import React from 'react';
import chroma from 'chroma-js';

function Filter({
  name, value, onChange, children,
  renderLabel = defaultRenderLabel,
}) {
  if (value) {
    return (
      <Flex
        align="center"
        gap={8}
        style={{
          border: `1px solid ${WL_CONFIG.colors.primary}`,
          borderRadius: 4,
          backgroundColor: chroma(WL_CONFIG.colors.primary).alpha(0.1).css(),
        }}
        className="px-4 py-1"
      >
        <span>
          <Typography.Text type="secondary">
            {name}
            :
            { ' '}

          </Typography.Text>
          {renderLabel(value)}
        </span>
        <CloseCircleOutlined onClick={() => onChange(null)} />
      </Flex>
    );
  }
  return React.cloneElement(children, {
    value,
    onChange,
  });
}

function defaultRenderLabel(value) {
  return value?.label || value || '-';
}


export default Filter;


